import React from 'react'

interface PracticeHubIconProps {
  size?: 'sm' | 'md' | 'lg'
  color?: string
}

const sizeMap = {
  sm: 24,
  md: 32,
  lg: 48,
}

export const PracticeHubIcon: React.FC<PracticeHubIconProps> = ({ size = 'md', color = '#B2CAFA' }) => {
  const iconSize = sizeMap[size]
  console.log('clr:', color)
  return (
    <svg width={iconSize} height={iconSize} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask0_15151_505"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="32"
        height="32"
      >
        <path d="M0 3.8147e-06H32V32H0V3.8147e-06Z" fill="white" />
      </mask>
      <g mask="url(#mask0_15151_505)">
        <path
          d="M2.34375 14.125H0.46875V17.875H2.34375"
          stroke={color}
          strokeWidth="0.9375"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M29.6562 17.875H31.5312V14.125H29.6562"
          stroke={color}
          strokeWidth="0.9375"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M11.7188 17.875H20.2812"
        stroke={color}
        strokeWidth="0.9375"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.2812 14.125H11.7188"
        stroke={color}
        strokeWidth="0.9375"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <mask
        id="mask1_15151_505"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="32"
        height="32"
      >
        <path d="M0 3.8147e-06H32V32H0V3.8147e-06Z" fill="white" />
      </mask>
      <g mask="url(#mask1_15151_505)">
        <path
          d="M9.84375 19.75C10.8793 19.75 11.7188 18.9106 11.7188 17.875V14.125C11.7188 13.0894 10.8793 12.25 9.84375 12.25"
          stroke={color}
          strokeWidth="1.4"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.15625 9.90625C5.15625 9.12963 4.52662 8.5 3.75 8.5C2.97338 8.5 2.34375 9.12963 2.34375 9.90625V22.0938C2.34375 22.8704 2.97338 23.5 3.75 23.5C4.52662 23.5 5.15625 22.8704 5.15625 22.0938"
          stroke={color}
          strokeWidth="1.4"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.15625 16.9375V23.9688C5.15625 25.2632 6.20556 26.3125 7.5 26.3125C8.79444 26.3125 9.84375 25.2632 9.84375 23.9688V8.03125C9.84375 6.73681 8.79444 5.6875 7.5 5.6875C6.20556 5.6875 5.15625 6.73681 5.15625 8.03125V17.5"
          stroke={color}
          strokeWidth="1.4"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.1562 12.25C21.1207 12.25 20.2812 13.0894 20.2812 14.125V17.875C20.2812 18.9106 21.1207 19.75 22.1562 19.75"
          stroke={color}
          strokeWidth="1.4"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.8438 9.90625C26.8438 9.12963 27.4734 8.5 28.25 8.5C29.0266 8.5 29.6562 9.12963 29.6562 9.90625V22.0938C29.6562 22.8704 29.0266 23.5 28.25 23.5C27.4734 23.5 26.8438 22.8704 26.8438 22.0938"
          stroke={color}
          strokeWidth="1.4"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.5 5.6875C25.7944 5.6875 26.8438 6.73681 26.8438 8.03125V23.9688C26.8438 25.2632 25.7944 26.3125 24.5 26.3125C23.2056 26.3125 22.1562 25.2632 22.1562 23.9688V8.03125C22.1562 6.73681 23.2056 5.6875 24.5 5.6875Z"
          stroke={color}
          strokeWidth="1.4"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}

export default PracticeHubIcon
